import React, { Component } from 'react';

class PageNotFound extends Component {
  render() {
    return <div className="App">Page not found</div>;
  }
}

export default PageNotFound;
